import { ReactNode } from "react";
import { cn } from "lib/utils";

type Props = {
  title?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  noPadding?: boolean;
};

const AdminCard = ({ title, action, children, className, noPadding }: Props) => (
  <div
    className={cn(
      "bg-white rounded-xl border border-slate-200/80 shadow-[0_1px_2px_rgba(15,23,42,0.04)]",
      !noPadding && "p-5",
      className
    )}
  >
    {(title || action) && (
      <div className="flex items-center justify-between mb-4">
        {title && <h3 className="text-[13px] font-semibold text-slate-700 tracking-wide">{title}</h3>}
        {action}
      </div>
    )}
    {children}
  </div>
);

export default AdminCard;
